import React, { useEffect, useState } from 'react';
import { scheduleMeeting } from '../../api';
import ModalHeader from './ModalHeader';
import SuccessMessage from './SuccessMessage';
import MeetingForm from './MeetingForm';

const CalendarModal = ({ isOpen, onClose, customerId, customerName }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [startTime, setStartTime] = useState('09:00');
  const [endTime, setEndTime] = useState('10:00');
  const [meetingType, setMeetingType] = useState('video');
  const [location, setLocation] = useState('Zoom');
  const [title, setTitle] = useState(`Meeting with ${customerName}`);
  const [notes, setNotes] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);


  useEffect(() => {
    if (customerName) {
      setTitle(`Meeting with ${customerName}`);
    }
  }, [customerName]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const formattedDate = selectedDate.toISOString().split('T')[0];

      const meetingId = `MTG${Date.now().toString().slice(-6)}`;

      const meetingData = {
        advisor_id: "ADV245", 
        created_at: new Date().toISOString(),
        customer_id: customerId,
        end_time: endTime,
        id: meetingId,
        location: location,
        meeting_date: formattedDate,
        meeting_type: meetingType,
        notes: notes,
        start_time: startTime,
        status: "scheduled",
        title: title
      };

      await scheduleMeeting(meetingData);

      setSuccess(true);
      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 2000);

    } catch (err) {
      console.error("Error scheduling meeting:", err);
      setError(err.message || "Failed to schedule meeting. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[1000] backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-[550px] max-h-[90vh] overflow-y-auto">
        <ModalHeader customerName={customerName} onClose={onClose} />

        {success ? (
          <SuccessMessage />
        ) : (
          <MeetingForm
            title={title}
            setTitle={setTitle}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            startTime={startTime}
            setStartTime={setStartTime}
            endTime={endTime}
            setEndTime={setEndTime}
            meetingType={meetingType}
            setMeetingType={setMeetingType}
            location={location}
            setLocation={setLocation}
            notes={notes}
            setNotes={setNotes}
            error={error}
            isSubmitting={isSubmitting}
            onSubmit={handleSubmit}
            onClose={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default CalendarModal;